import React, { useState } from "react";
import { Alert, Form } from "rsuite";
import Whisper from "rsuite/es/Whisper";
import Popover from "rsuite/es/Popover";
import Icon from "rsuite/es/Icon";

import { copyToClipboard } from "utils";
import m from "definedMessages";
import {
    StyledContainerColumn,
    StyledContainerRow,
    StyledLabel,
    StyledButton,
} from "./TrunkFormRefactored.styles";

const ContentSupplierForm = ({ error, model, formatMessage, initialValues, setError, setMoreData }) => {
    const [formData, setFormData] = useState(initialValues);

    const errorObject = error["contentSupplierError"] || {};

    return (<>
        <Form
            model={model}
            layout="inline"
            formDefaultValue={{ ...initialValues }}
            formValue={formData}
            onChange={(value) => {
                const formCheck = model.check(value);
                const errors = {};

                const formErrors = Object.keys(formCheck).reduce((data, key) => {
                    if (formCheck[key].hasError) {
                        data[key] = formCheck[key].errorMessage;
                    }
                    return data;
                }, errors);

                setError((prevValue) => {
                    return {
                        ...prevValue,
                        contentSupplierError: formErrors
                    };
                });
                setMoreData(value);
                setFormData(value);
            }}
            style={{ margin: "0px", width: "100%" }}
            formError={errorObject}
        >
            <StyledContainerColumn mb={0} mt={20}>
                <StyledContainerRow maxWidth={180} mb={0}>
                    <StyledLabel compact display="block" mr={15} ml={0}>
                        <Whisper
                            placement="rightStart"
                            trigger="hover"
                            controlId="control-id-hover-enterable"
                            speaker={
                                <Popover>
                                    You can copy postback URL by clicking on this button
                                </Popover>
                            }
                            enterable
                        >
                            <Icon icon="info" />
                        </Whisper>
                    </StyledLabel>
                    <StyledButton
                        withoutMargin
                        className="right"
                        onClick={() => {
                            copyToClipboard(initialValues.postback_info);
                            Alert.success(formatMessage(m.copied));
                        }}
                        disabled={!initialValues.postback_info || Object.keys(errorObject).length}
                    >
                        Get postback URL
                    </StyledButton>
                </StyledContainerRow>
            </StyledContainerColumn>
        </Form>
    </>);
};

export default ContentSupplierForm;
